import { OldSchedulerHelper } from '../../../../../../../utils/maintenanceWindow/patchManagement/OldSchedulerHelper';
import { OldScheduler } from '../../../../../../../types/common/maintenanceWindowPatchManagementTypes';
import { RecurrenceOptions } from '../../../../../../../types/common/schedulerTypes';

export class OldSchedulerHelperV2 extends OldSchedulerHelper {
  getShortDescription(data: OldScheduler): string {
    // immediately recurrence has a different text for Patch Management V2
    if (data.recurrence === RecurrenceOptions.IMMEDIATELY) {
      return this.dependencies.translateFn('Immediately after scan');
    }

    return super.getShortDescription(data);
  }
}
